import { useAtom } from "@reatom/npm-react"

import { Checkbox, Control, Img } from "ui-kit/components-branded/index"
import { workingWithAtom } from "modules/PsyCatalog/common/models/filterForm"

export function WorkingWithFilters() {
    const [value] = useAtom(workingWithAtom.inputValue)
    return (
        <div>
            <div className="strike advanced-search-block">
                <button type="button" className="strike-content" />
            </div>
            <p className="advanced-search-explanation">
                Все наши психологи придерживаются принципов толерантности и&nbsp;инклюзивности.
                Мы&nbsp;отображаем этот критерии для психологов, кто имеет большой опыт
                и&nbsp;знание контекста в&nbsp;работе с&nbsp;каждой конкретной социальной группой.
            </p>
            <div className="d-flex justify-content-center flex-wrap">
                <Control>
                    <Checkbox
                        id="friendly"
                        checked={value.friendly}
                        onChange={() => {
                            workingWithAtom.onChange("friendly")
                        }}
                    >
                        <Img style={{ width: "22px", height: "22px" }} src="purple_heart.png" />{" "}
                        френдли
                    </Checkbox>
                </Control>
                <Control>
                    <Checkbox
                        id="fem"
                        checked={value.fem}
                        onChange={() => {
                            workingWithAtom.onChange("fem")
                        }}
                    >
                        фем-френдли
                    </Checkbox>
                </Control>
                <Control>
                    <Checkbox
                        id="believer"
                        checked={value.believer}
                        onChange={() => {
                            workingWithAtom.onChange("believer")
                        }}
                    >
                        работает с&nbsp;верующими
                    </Checkbox>
                </Control>
                <Control>
                    <Checkbox
                        id="cancer"
                        checked={value.cancer}
                        onChange={() => {
                            workingWithAtom.onChange("cancer")
                        }}
                    >
                        работает с&nbsp;онкопациентами
                    </Checkbox>
                </Control>
            </div>
        </div>
    )
}
